export default function Logo({ size = "default", showTagline = true, bordered = false, className = "" }) {
    const sizes = {
        small: { img: "h-11", line: "text-[8px]", lh: "leading-[1.55]" },
        default: { img: "h-14 sm:h-[72px] md:h-20", line: "text-[9px] sm:text-[11px] md:text-[13px]", lh: "leading-[1.5]" },
        large: { img: "h-24", line: "text-sm md:text-base", lh: "leading-[1.5]" },
    };
    const s = sizes[size];

    return (
        <div className={`flex items-center gap-4 ${className}`} data-testid="pes-logo">
            <div className="transition-all duration-300">
                <img
                    src="https://customer-assets.emergentagent.com/job_pes-modern/artifacts/ahe6v17i_IMG_0020.png"
                    alt="PES — Professional Engineering Solutions"
                    className={`${s.img} w-auto object-contain transition-[filter] duration-300`}
                    style={{
                        filter: bordered
                            ? "brightness(1.85) saturate(1.45) contrast(1.05) drop-shadow(0.35px 0 0 rgba(148,163,184,0.9)) drop-shadow(-0.35px 0 0 rgba(148,163,184,0.9)) drop-shadow(0 0.35px 0 rgba(148,163,184,0.9)) drop-shadow(0 -0.35px 0 rgba(148,163,184,0.9))"
                            : "brightness(1.85) saturate(1.45) contrast(1.0) drop-shadow(0.25px 0 0 rgba(148,163,184,0.75)) drop-shadow(-0.25px 0 0 rgba(148,163,184,0.75)) drop-shadow(0 0.25px 0 rgba(148,163,184,0.75)) drop-shadow(0 -0.25px 0 rgba(148,163,184,0.75))",
                    }}
                />
            </div>
            {showTagline && (
                <div className={`flex flex-col items-start ${s.lh} border-l border-blue-400/25 pl-3 sm:pl-4`}>
                    <span
                        className={`${s.line} tracking-[0.32em] uppercase font-bold`}
                        style={{ color: "#60A5FA" }}
                    >
                        Professional
                    </span>
                    <span
                        className={`${s.line} tracking-[0.32em] uppercase font-bold text-white`}
                    >
                        Engineering
                    </span>
                    <span className={`${s.line} text-slate-400 tracking-[0.32em] uppercase font-medium`}>
                        Solutions
                    </span>
                </div>
            )}
        </div>
    );
}
